import React, { createContext, useContext } from 'react'
import type { Deal } from '../types/deal'

// DealsProvider is intentionally a thin shell in this change. The real React
// Query wiring (useDealsQuery, mutations, optimistic updates) lands in
// add-deals-list-and-filters; this file only freezes the interface shape so
// downstream components compile against a stable contract.
interface DealsContextValue {
  /** True once a Provider is mounted; downstream code can lift the guard. */
  isReady: boolean
  /**
   * Snapshot of deals the active query has loaded. Empty in this foundation
   * change — populated by useDealsQuery in the next change.
   */
  deals: Deal[]
}

const DealsContext = createContext<DealsContextValue | null>(null)

const placeholderValue: DealsContextValue = {
  isReady: true,
  deals: [],
}

export const DealsProvider: React.FunctionComponent = (props) => {
  return <DealsContext.Provider value={placeholderValue}>{props.children}</DealsContext.Provider>
}

export function useDeals(): DealsContextValue {
  const ctx = useContext(DealsContext)
  if (!ctx) throw new Error('useDeals must be used inside <DealsProvider>')
  return ctx
}
